function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { getAction, uploadAction } from "@/api/manage";
var uuidGenerator = function uuidGenerator() {
  var s = [];
  var hexDigits = '0123456789abcdef';
  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  s[14] = '4'; // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr(s[19] & 0x3 | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = '-';
  var uuid = s.join('');
  return uuid;
};
export default {
  name: "JMavonEditor",
  components: {},
  data: function data() {
    return {
      myValue: this.value,
      toolbars: _defineProperty(_defineProperty({
        bold: true,
        // 粗体
        italic: true,
        // 斜体
        header: true,
        // 标题
        underline: true,
        // 下划线
        mark: true,
        // 标记
        superscript: true,
        // 上角标
        quote: true,
        // 引用
        ol: true,
        // 有序列表
        link: true,
        // 链接
        imagelink: true,
        // 图片链接
        help: true,
        // 帮助
        code: true,
        // code
        subfield: true,
        // 是否需要分栏
        fullscreen: true,
        // 全屏编辑
        readmodel: true,
        // 沉浸式阅读
        /* 1.3.5 */
        undo: true,
        // 上一步
        trash: true,
        // 清空
        save: false,
        // 保存（触发events中的save事件）
        /* 1.4.2 */
        navigation: true,
        // 导航目录
        /* 2.1.8 */
        alignleft: true,
        // 左对齐
        aligncenter: true,
        // 居中
        alignright: true
      }, "subfield", true), "preview", true),
      uploadAction: {
        local: window._CONFIG["domianURL"] + "/sys/common/upload",
        qiniu: "//upload-" + this.$store.getters.tenantInfo.qiniuArea + ".qiniup.com",
        oss: "",
        cos: ""
      },
      tokenAction: {
        qiniu: "/common/qiniu/getToken"
      },
      downloadUrl: {
        local: this.$store.getters.tenantInfo.staticDomain + '/',
        qiniu: this.$store.getters.tenantInfo.qiniuDomain + '/'
      }
    };
  },
  props: {
    value: {
      type: String,
      required: false
    },
    triggerChange: {
      type: Boolean,
      default: false,
      required: false
    },
    //是否允许编辑
    editable: {
      type: Boolean,
      default: true,
      required: false
    },
    //双栏
    subfield: {
      type: Boolean,
      default: true,
      required: false
    },
    //默认展示编辑区域 edit preview
    defaultOpen: {
      type: String,
      required: false,
      default: "preview"
    }
  },
  watch: {
    value: function value(newValue) {
      this.myValue = newValue == null ? "" : newValue;
    },
    myValue: function myValue(newValue) {
      if (this.triggerChange) {
        this.$emit("change", newValue);
      } else {
        this.$emit("input", newValue);
      }
    }
  },
  created: function created() {},
  methods: {
    imgAdd: function imgAdd(pos, file) {
      var _this = this;
      var that = this;
      getAction(that.tokenAction.qiniu, {}).then(function (token_res) {
        if (token_res.success) {
          var formData = new FormData();
          formData.append("file", file, uuidGenerator() + file.name);
          formData.append("token", token_res.result);
          formData.append("key", uuidGenerator() + file.name);
          uploadAction(that.uploadAction.qiniu, formData, function (progressEvent) {
            var complete = progressEvent.loaded / progressEvent.total * 100 | 0;
            console.log(complete);
          }).then(function (res) {
            var url = that.downloadUrl.qiniu + res.key;
            console.log(url);
            _this.$refs.md.$img2Url(pos, url);
          }).catch(function () {});
        } else {
          that.$message.error(token_res.message);
        }
      });
    },
    imgDel: function imgDel(filename) {},
    save: function save(value, render) {
      console.log(value);
      console.log(render);
    },
    change: function change(value, render) {},
    clear: function clear() {
      this.myValue = "";
    }
  }
};